// Pure mode-selection logic for SupportTicketModal, pulled out so the
// copilot-gating decision is testable without a component-test harness (this
// repo has none - see src/helpers/*.test.js for the pattern these follow).
//
// The modal is mounted once, permanently, in BaseHeader for every product -
// only `show` toggles, so its `mode` state survives a close. If the default
// mode or the render gates below ever go stale relative to `copilotEnabled`,
// a copilot-disabled tenant (Gitcha, or any BLS tenant with the flag off)
// can end up shown the BLS assistant, or locked out of the ticket form
// entirely, after the modal has been opened and closed once. See
// SupportTicketModal.js's reset()/render for where these are used.

// The mode `reset()` (on close, or after a successful submit) and the
// initial `useState` should return to.
export function defaultTicketModalMode(copilotEnabled) {
  return copilotEnabled ? "chat" : "ticket";
}

// Whether the Copilot chat panel should render. Copilot is a BLS-only
// feature - if the flag is off, this must be false regardless of `mode`
// (which can be stale from a prior render where the flag was on).
export function shouldShowChatPanel(copilotEnabled, mode) {
  return copilotEnabled && mode === "chat";
}

// Whether the ticket form (whichever step) should render. Copilot-disabled
// tenants only ever have the ticket form, so it must render irrespective of
// `mode` there - `mode` only matters once both surfaces are actually
// reachable (copilot on).
export function shouldShowTicketForm(copilotEnabled, mode) {
  return !copilotEnabled || mode === "ticket";
}
